const contextMenuList: Array<ContextMenuItem> = [
    {
        name: '剪切',
        shortCutKey: 'Ctrl + X',
        type: 'cut',
        children: []
    },
    {
        name: '复制',
        shortCutKey: 'Ctrl + C',
        type: 'copy',
        children: []
    },
    {
        name: '粘贴',
        shortCutKey: 'Ctrl + V',
        type: 'paste',
        children: []
    },
    {
        name: '删除',
        shortCutKey: 'Delete',
        type: 'del',
        children: []
    },
    {
        name: '排序',
        shortCutKey: '',
        type: 'layerCubeSort',
        children: [
            {
                name: '售价',
                shortCutKey: '',
                type: 'sortBySales',
                children: [
                    {
                        name: '升序',
                        shortCutKey: '',
                        type: 'sortBySalesUp',
                        children: []
                    },
                    {
                        name: '降序',
                        shortCutKey: '',
                        type: 'sortBySalesDown',
                        children: []
                    }
                ]
            },
            {
                name: '品牌',
                shortCutKey: '',
                type: 'sortByBrand',
                children: [
                    {
                        name: '升序',
                        shortCutKey: '',
                        type: 'sortByBrandUp',
                        children: []
                    },
                    {
                        name: '降序',
                        shortCutKey: '',
                        type: 'sortByBrandDown',
                        children: []
                    }
                ]
            },
            {
                name: '小分类',
                shortCutKey: '',
                type: 'sortByType',
                children: [
                    {
                        name: '升序',
                        shortCutKey: '',
                        type: 'sortByTypeUp',
                        children: []
                    },
                    {
                        name: '降序',
                        shortCutKey: '',
                        type: 'sortByTypeDown',
                        children: []
                    }
                ]
            }
        ]
    },
    {
        name: '隔开',
        shortCutKey: '',
        type: 'addSpace',
        children: []
    },
    {
        name: '编辑文本框',
        shortCutKey: '',
        type: 'editTextarea',
        children: []
    },
    {
        name: '左侧断开',
        shortCutKey: '',
        type: 'breakLeft',
        children: []
    },
    {
        name: '右侧断开',
        shortCutKey: '',
        type: 'breakRight',
        children: []
    }
];

export {
    contextMenuList
};
